var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"cms-localizacao",style:({ 'height': _vm.altura })},[_c('iframe',{staticClass:"cms-localizacao__iframe",style:({ 'height': _vm.altura }),attrs:{"src":_vm.caminhoIframe(),"frameborder":"0","allowfullscreen":""}})])}
var staticRenderFns = []

export { render, staticRenderFns }